<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link :to="`/layout/project-list?page=${page}`">项目展示</router-link></li>
                <li class="currentNode"><a>项目详情</a></li>
            </ul>
            <div class="page-main">
                <div class="page-main-tp">
                    <h3>{{ title }}</h3>
                    <p class="subtitle">发布时间：{{ publishTime }}</p>
                </div>
                <el-divider></el-divider>
                <div class="page-main-btm content-detail" v-html="content"> </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getKnowledgeDetail
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            detailId: '',
            page: '',
            publishTime: '',
            title: '',
            subTitle: '',
            content: '',
            parentLink:'',
            parentNav: '',
            description: '',
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page ? this.$route.query.page : 1;
        this.getKnowledgeDetail();
    },
    methods: {
        getKnowledgeDetail() {
            let params = {
                id: this.detailId
            };
            getKnowledgeDetail(params).then(res => {
                console.log(res);
                if (res.Code == 1 && res.Data.length!==0) {
                    this.publishTime = res.Data.UpdateTime;
                    this.title = res.Data.Title;
                    this.subTitle = res.Data.SubTitle;
                    this.content = res.Data.Content;
                    this.description = res.Data.Description;
                } else {
                    this.$message.error("详情请求失败");
                }
            })
        },
    },
}
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
.page-main-tp {
    display: block;
}
</style>